//-----------------------------------------------------------------------
// Copyright © 2022 ManpowerGroup. All Rights Reserved.
//-----------------------------------------------------------------------

/* eslint-disable prettier/prettier */
import React, { useEffect, useState, useContext } from "react";
import { Card, Col, Container, Row, Button, Form, InputGroup } from "react-bootstrap";
import { Search } from "react-feather";
import Select from 'react-select';
import { CreateNewUserActions } from "./createNewUserActions";
import { CandidatePageActions } from "../candidatePageActions";
import { Context } from "../common/context/Context";
import AlertMessage from "../common/alertMessages/alertMessages";
import ErrorAlertMessage from "../common/alertMessages/errorAlertMessage";
import { UserDetailsActions } from "./userDetailsActions";
import "./index.css";
import { checkEnvTypeFromAzure } from "../aAdminTabTeam2/hooksAndFunctions/functions/checkEnvTypeFromAzure";
import { useAccessTypes } from "../aAdminTabTeam2/hooksAndFunctions/customHooks/useAccessTypes";

const CreateNewUser = () => {

    const {
        isEnterpriseAdmin: isEnterpriseAdminType,
        clientPortalAdminType,
        candidatePortalAdminType,
    } = useAccessTypes()

    const { isClientPortalAdmin, hasA1Access, hasA2Access, hasA3Access } = clientPortalAdminType
    const { isCandidatePortalAdmin, hasSuperAdminAccess, hasAdminAccess, hasCoachAccess, hasCoachAdminAccess } = candidatePortalAdminType

    /** func call  to know type of deployment environment*/
    /**should be removed after Phase 2 deployment in prod */
    const { isProdEnv } = checkEnvTypeFromAzure()

    // console.log("isProdEnv", isProdEnv)

    const context = useContext(Context);
    const UserCoach = "Coach";
    const UserCoachAdmin = "Coach Admin"
    const [activeEmail, setActiveEmail] = useState('')
    const [graphData, setGraphData] = useState({
        id: '',
        firstName: '',
        lastName: '',
        preferredName: '',
        email: '',
        preferredNumber: '',
        affiliateEmail: ''
    });
    const [weekDaysList, setWeekDaysList] = useState([]);
    const [userProfileData, setUserProfileData] = useState({
        bio: '',
        expertise: '',
        linkedInID: '',
        twitterID: '',
        language: ''
    })
    const [startTime, setStartTime] = useState();
    const [endTime, setEndTime] = useState();
    const [hoursList, setHoursList] = useState()
    const [cronofyServiceAccountName, setCronofyServiceAccountName] = useState();
    const [cronofyTime, setCronofyTime] = useState();
    const [status, setStatus] = useState()
    const [createNewUserJson, setCreateNewUserJson] = useState({});
    const [serviceOfficeList, setServiceOfficeList] = useState([]);
    const [userRoleList, setUserRoleList] = useState([]);
    const [languageList, setLanguageList] = useState([]);
    const [userServiceOfficeList, setUserServiceOfficeList] = useState([]);
    const [country, setCountry] = useState("");
    const [language, setLanguage] = useState([]);
    const [timeZoneOptions, setTimeZoneOptions] = useState([]);
    const [timeZone, setTimeZone] = useState("");
    const [userRole, setUserRole] = useState("");
    const [clientUserRole, setClientUserRole] = useState("");
    const [serviceOffice, setServiceOffice] = useState("");
    const [userRoleCountry, setUserRoleCountry] = useState(null);
    const [userRoleServiceOffice, setUserRoleServiceOffice] = useState(null);
    const [userRoleCountryList, setUserRoleCountryList] = useState([]);
    const [alertForSearch, setAlertForSearch] = useState({
        message: "",
        type: "",
        showAlert: false
    })
    const [errorAlert, setErrorAlert] = useState({
        showAlert: false
    })
    const [weekDay, setWeekDay] = useState(null);
    const [cronofyTimeZone, setCronofyTimeZone] = useState();
    const [cronofyServiceAccount, setCronofyServiceAccount] = useState();

    /**role adding logic */
    const [isEnterpriseAdmin, setIsEnterpriseAdmin] = useState(false)
    const [candidatePortalRoleList, setCandidatePortalRoleList] = useState([])
    const [clientPortalRoleList, setClientPortalRoleList] = useState([])

    const ADMIN = 'Admin';
    const SUPER_ADMIN = 'Super Admin';
    const ENPTERPRISE_ADMIN = 'Enterprise Admin';
    const COACH = 'Coach';
    const COACH_ADMIN = 'Coach Admin'

    const showErrorModal = () => {
        let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));
        refErrorMessageAlert.showAlert = false;
        setErrorAlert(refErrorMessageAlert)
    }

    const getWeekDaysList = async (weekDaysLists) => {

        let selectAllLabel = fetchCreateNewUserLabel('CreateNewUser.SelectAllLabel');
        let selectAllValue = fetchCreateNewUserLabel('CreateNewUser.SelectAllValue');
        let selectAllOption = { label: selectAllLabel, value: selectAllValue }
        let weekDaysListsHardCoded = [];
        let weekDays = [
            {
                id: 0,
                label: 'Monday'
            },
            {
                id: 1,
                label: 'Tuesday'
            },
            {
                id: 2,
                label: 'Wednesday'
            },
            {
                id: 3,
                label: 'Thursday'
            },
            {
                id: 4,
                label: 'Friday'
            },
            {
                id: 5,
                label: 'Saturday'
            },
            {
                id: 6,
                label: 'Sunday'
            }
        ]
        weekDaysListsHardCoded.push(weekDays);
        let weekDaysListData = weekDaysLists && weekDaysLists.length > 0 ? weekDaysLists : weekDaysListsHardCoded;
        let weekDaysOptions = weekDaysListData?.map((item) => ({ label: item?.label, value: item?.id }))
        setWeekDaysList([selectAllOption, ...weekDaysOptions]);
    }

    const getHoursList = async (hoursLists) => {

        let hoursListsHardCoded = [];
        let hours = [
            {
                id: 0,
                label: '00:00'
            },
            {
                id: 1,
                label: '01:00'
            },
            {
                id: 2,
                label: '02:00'
            },
            {
                id: 3,
                label: '03:00'
            },
            {
                id: 4,
                label: '04:00'
            },
            {
                id: 5,
                label: '05:00'
            },
            {
                id: 6,
                label: '06:00'
            },
            {
                id: 0,
                label: '07:00'
            },
            {
                id: 1,
                label: '08:00'
            },
            {
                id: 2,
                label: '09:00'
            },
            {
                id: 3,
                label: '10:00'
            },
            {
                id: 4,
                label: '11:00'
            },
            {
                id: 5,
                label: '12:00'
            },
            {
                id: 6,
                label: '13:00'
            },
            {
                id: 0,
                label: '14:00'
            },
            {
                id: 1,
                label: '15:00'
            },
            {
                id: 2,
                label: '16:00'
            },
            {
                id: 3,
                label: '17:00'
            },
            {
                id: 4,
                label: '18:00'
            },
            {
                id: 5,
                label: '19:00'
            },
            {
                id: 6,
                label: '20:00'
            },
            {
                id: 0,
                label: '21:00'
            },
            {
                id: 1,
                label: '22:00'
            },
            {
                id: 2,
                label: '23:00'
            }
        ]
        hoursListsHardCoded.push(hours);
        let hoursListData = hoursLists && hoursLists.length > 0 ? hoursLists : hoursListsHardCoded;
        let hoursOptions = hoursListData?.map((item) => ({ label: item?.label, value: item?.id }))
        setHoursList([...hoursOptions]);
    }

    const fetchCronofyTimeZone = async (countryCode) => {
        await UserDetailsActions.GetCronofyTimeZone(countryCode).then(
            (res) => {
                if (res.status === 200 || res.status === 204) {
                    setCronofyTimeZone(res?.data);
                } else {
                    window.scrollTo(0, 0)
                }
            },
            (err) => {
                console.log(err)
            }
        );
    }

    const fetchUserDetails = async () => {
        setGraphData({
            firstName: '',
            lastName: '',
            preferredName: '',
            email: '',
            preferredNumber: '',
            affiliateEmail: ''
        });
        let refAlert = JSON.parse(JSON.stringify(alertForSearch));
        await CreateNewUserActions.GetUserDetails(activeEmail).then(
            (res) => {
                if (res.status === 200 || res.status === 204) {
                    let graphApiData = res?.data;
                    let userDetails = {
                        id: graphApiData?.id,
                        firstName: graphApiData?.givenName,
                        lastName: graphApiData?.surname,
                        preferredName: graphApiData?.displayName,
                        email: graphApiData?.mail,
                        preferredNumber: graphApiData?.businessPhones[0]
                    }
                    setGraphData(userDetails);
                }
                else if (res.status === 404) {
                    refAlert.showAlert = true;
                    refAlert.type = "danger";
                    refAlert.message = fetchCreateNewUserLabel('CreateNewUser.SearchErrorMessage');
                    setAlertForSearch(refAlert)
                }
            },
            (err) => {
                console.log(err);
            }
        );
    }

    const handleSearchChange = (e) => {
        setActiveEmail(e.target.value);
    }


    const getServiceOffice = async (countryCode) => {
        let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));
        await CandidatePageActions.GetServiceOffice(countryCode).then(
            (res) => {
                if (res.status === 200 || res.status === 204) {
                    setServiceOfficeList(res.data && res.data)
                }
                else {
                    refErrorMessageAlert.showAlert = true;
                    setErrorAlert(refErrorMessageAlert);
                    window.scrollTo(0, 0);
                }
            },
            (err) => {
                console.log(err);
            }
        );
    }
    const getUserServiceOffice = async (countryCode) => {
        let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));
        await CandidatePageActions.GetServiceOffice(countryCode).then(
            (res) => {
                if (res.status === 200 || res.status === 204) {
                    let serviceOfficeOptions = res?.data?.map((item) => ({ label: item?.rightOfficeName, value: JSON.parse(JSON.stringify(item)) }))
                    setUserServiceOfficeList(serviceOfficeOptions)
                }
                else {
                    refErrorMessageAlert.showAlert = true;
                    setErrorAlert(refErrorMessageAlert);
                    window.scrollTo(0, 0);
                }
            },
            (err) => {
                console.log(err);
            }
        );
    }

    const getCountriesList = async () => {
        let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));
        let locale = "en-US";
        let key = "country";
        let selectAllLabel = fetchCreateNewUserLabel('CreateNewUser.SelectAllLabel');
        let selectAllValue = fetchCreateNewUserLabel('CreateNewUser.SelectAllValue');
        let selectAllOption = { label: selectAllLabel, value: selectAllValue }
        CandidatePageActions.GetCountriesList(locale, key).then(
            (res) => {
                if (res.status === 200 || res.status === 204) {
                    let countryLists = [];
                    res?.data[0]?.items?.forEach((item) => {
                        let country = {}
                        country.title = item.title;
                        item?.standardCodes?.forEach((subItem) => {
                            if (subItem?.itemCodeStandardName === 'rt') {
                                country.standardCodeValue = subItem?.standardCodeValue
                                countryLists.push(country);
                            }
                        })
                    })
                    context.setCountryList(countryLists)
                    let countryOptions = countryLists?.map((item) => ({ label: item?.title, value: item?.standardCodeValue }))
                    setUserRoleCountryList([selectAllOption, ...countryOptions]);
                }
                else {
                    refErrorMessageAlert.showAlert = true;
                    setErrorAlert(refErrorMessageAlert);
                    window.scrollTo(0, 0);
                }
            },
            (err) => {
                console.log(err);
            }
        );
    }

    const handleWeekDaysChange = (value) => {
        setWeekDay(value);
    }

    const fetchUserRoles = async () => {
        let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));

        CreateNewUserActions.GetUserRole().then(
            (res) => {
                if (res.status === 200 || res.status === 204) {
                    setUserRoleList(res?.data);
                }
                else {
                    refErrorMessageAlert.showAlert = true;
                    setErrorAlert(refErrorMessageAlert);
                    window.scrollTo(0, 0);
                }
            },
            (err) => {
                console.log(err);
            }
        );
    }

    const fetchLanguage = async (country) => {
        let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));

        CreateNewUserActions.GetLanguage(country).then(
            (res) => {
                if (res.status === 200 || res.status === 204) {
                    setLanguageList(res?.data);
                }
                else {
                    refErrorMessageAlert.showAlert = true;
                    setErrorAlert(refErrorMessageAlert);
                    window.scrollTo(0, 0);
                }
            },
            (err) => {
                console.log(err);
            }
        );
    }

    const handleCountryChange = (e) => {
        let country = e.target.value;
        setCountry(country);
        if (country) {
            fetchLanguage(country);
            fetchCronofyTimeZone(country)
            getServiceOffice(country);
        }
        else {
            setServiceOffice('');
        }
    }
    const handleUserCountryChange = (value) => {
        setUserRoleCountry(value);
        if (value?.length > 0) {
            let selectedCountries = value.map((item) => item.value).join(',');
            getUserServiceOffice(selectedCountries);
        }
        else {
            setUserRoleServiceOffice([]);
        }

    }
    const handleServiceOfficeChange = (e) => {
        let office = e.target.value;
        setServiceOffice(office);
    }
    const handleUserServiceOfficeChange = (value) => {
        setUserRoleServiceOffice(value);
    }

    const fetchCreateNewUserJson = async () => {
        let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));
        await CreateNewUserActions.GetCreateNewUserJSON().then(
            (res) => {
                if (res.status === 200 || res.status === 204) {
                    setCreateNewUserJson(JSON.parse(JSON.stringify(res?.data)));
                    let daysList = res?.data?.Properties?.WeekDaysList;
                    let hours = res?.data?.Properties?.HoursList;
                    getWeekDaysList(daysList && daysList);
                    getHoursList(hours && hours);
                }
                else {
                    refErrorMessageAlert.showAlert = true;
                    setErrorAlert(refErrorMessageAlert);
                    window.scrollTo(0, 0);
                }
            },
            (err) => {
                console.log(err);
            }
        );
    }
    const fetchCreateNewUserLabel = (key) => {
        let refJsonContent = JSON.parse(JSON.stringify(createNewUserJson));
        let label = "";

        refJsonContent?.Properties?.Labels?.map((x) => {
            if (x.Key === key) {
                label = x.Phrase;
            }
        });

        return label;
    };

    const [alert, setAlert] = useState({
        message: "",
        type: "",
        showAlert: false
    })

    const fetchWeeklyPeriods = () => {
        if (fetchUserRole(userRole) === ADMIN || fetchUserRole(userRole) === SUPER_ADMIN || fetchUserRole(userRole) === ENPTERPRISE_ADMIN)
            return;
        let weeklyPeriods = weekDay?.map((item) => ({ day: item?.label.toLowerCase(), start_time: startTime && startTime, end_time: endTime && endTime }));
        return weeklyPeriods;
    }

    const fetchUserRole = (roleIds) => {
        let rolesList = userRoleList?.filter((x) => x.roleId == roleIds);
        rolesList = rolesList[0]?.role;
        return rolesList;
    }

    const fetchUserRoleId = (role) => {
        let rolesList = userRoleList?.filter((x) => x.role == role);
        rolesList = rolesList[0]?.roleId;
        return rolesList;
    }

    /**role object for create API payload */
    const [roleObjForPayload, setRoleObjForPayload] = useState({
        Roleid: '',
        Role: '',
    })

    useEffect(() => {
        if (!!isEnterpriseAdmin) {
            setRoleObjForPayload({
                Roleid: fetchUserRoleId(ENPTERPRISE_ADMIN) || "",
                Role: ENPTERPRISE_ADMIN || "",
            })
        } else {
            if (!!userRole) {
                setRoleObjForPayload({
                    Roleid: userRole || "",
                    Role: fetchUserRole(userRole) || ""
                })
            } else {
                /**RoleId is mandatory so if empty pass either clientPortalRoleId */
                setRoleObjForPayload({
                    Roleid: clientUserRole || "",
                    Role: fetchUserRole(clientUserRole) || "",
                })
            }
        }
    }, [isEnterpriseAdmin, userRole, clientUserRole])


    const createNewUser = () => {
        let office = serviceOffice && JSON.parse(serviceOffice);
        let refAlert = JSON.parse(JSON.stringify(alert));
        let responseMessage = "Email address exist in the system";

        let payloadWithoutCoach = {
            "ActiveDirectoryId": process.env.REACT_APP_AD_CLIENT_ID,
            "FirstName": graphData.firstName,
            "LastName": graphData.lastName,
            "CountryCode": country,
            "EmailAddress": graphData.email,
            "timeZone": timeZone,
            "ContactNo": graphData.preferredNumber,
            "ApplicationLanguage": language,
            "ServiceOfficeId": office?.rightOfficeId,
            "ServiceOfficeName": office?.rightOfficeName,
            "IsEnterpriseAdmin": isEnterpriseAdmin,
            "ClientPortalAdminRoleId": isEnterpriseAdmin ? fetchUserRoleId(ENPTERPRISE_ADMIN) : !!clientUserRole ? clientUserRole : '',
            "Role": {
                // "Roleid": isEnterpriseAdmin ? fetchUserRoleId(ENPTERPRISE_ADMIN) : userRole === 'Select User Role' ? '' : userRole,
                // "Role": isEnterpriseAdmin ? ENPTERPRISE_ADMIN : fetchUserRole(userRole),
                ...roleObjForPayload,
                "serviceOffices": userRoleServiceOffice?.map((item) => ({
                    "ServiceOfficeId": item?.value?.rightOfficeId,
                    "CountryCode": item?.value?.countryCode, "ServiceOfficeName": item?.value?.rightOfficeName
                }))
            }
        }

        let payloadWithCoach = {
            "ActiveDirectoryId": process.env.REACT_APP_AD_CLIENT_ID,
            "FirstName": graphData.firstName,
            "LastName": graphData.lastName,
            "CountryCode": country,
            "EmailAddress": graphData.email,
            "timeZone": timeZone,
            "ContactNo": graphData.preferredNumber,
            "ApplicationLanguage": language,
            "ServiceOfficeId": office?.rightOfficeId,
            "ServiceOfficeName": office?.rightOfficeName,
            "IsEnterpriseAdmin": isEnterpriseAdmin,
            "ClientPortalAdminRoleId": isEnterpriseAdmin ? fetchUserRoleId(ENPTERPRISE_ADMIN) : !!clientUserRole ? clientUserRole : "",
            "Role": {
                // "Roleid": isEnterpriseAdmin ? fetchUserRoleId(ENPTERPRISE_ADMIN) : userRole === 'Select User Role' ? '' : userRole,
                // "Role": isEnterpriseAdmin ? ENPTERPRISE_ADMIN : fetchUserRole(userRole),
                ...roleObjForPayload,
                "serviceOffices": userRoleServiceOffice?.map((item) => ({
                    "ServiceOfficeId": item?.value?.rightOfficeId,
                    "CountryCode": item?.value?.countryCode, "ServiceOfficeName": item?.value?.rightOfficeName
                }))
            },
            "ServiceAccountId": cronofyServiceAccountName && cronofyServiceAccountName,
            "schedulingAvailability": {
                "tzid": cronofyTime,
                "weekly_periods": fetchWeeklyPeriods()
            },
            "Bio": userProfileData?.bio,
            "Expertise": userProfileData?.expertise,
            "Language": userProfileData?.language,
            "SocialIdDetails": `${userProfileData?.linkedInID},${userProfileData?.twitterID}`,
            "Username": `${graphData.lastName},${graphData.firstName}`,
            "IsActive": status && status,
        }

        //let payload = (userRole == "2d9917fe-7720-ed11-bd6e-501ac574d42d" || userRole == "2e9917fe-7720-ed11-bd6e-501ac574d42d") ? payloadWithCoach : payloadWithoutCoach;

        let payload = {}

        if (fetchUserRole(userRole) === COACH || fetchUserRole(userRole) === COACH_ADMIN) {
            payload = payloadWithCoach
        } else {
            payload = payloadWithoutCoach
        }

        // let payload = (fetchUserRole(userRole) == COACH || fetchUserRole(userRole) == COACH_ADMIN) ? payloadWithCoach : payloadWithoutCoach;

        CreateNewUserActions.CreateNewUser(payload).then(
            (res) => {
                if (res.status === 200 || res.status === 202) {
                    trackAction(graphData.firstName, graphData.preferredName, userRole)
                    refAlert.showAlert = true;
                    refAlert.type = "success";
                    refAlert.message = fetchCreateNewUserLabel('CreateNewUser.CreateSuccessMessage');
                }
                else if (res.status === 500 || res.status === 401) {
                    refAlert.showAlert = true;
                    refAlert.type = "danger";
                    refAlert.message = fetchCreateNewUserLabel('CreateNewUser.CreateErrorMessage');
                } else if (res.status === 400 || res.status === responseMessage) {
                    refAlert.showAlert = true;
                    refAlert.type = "danger";
                    refAlert.message = fetchCreateNewUserLabel('CreateNewUser.EmailAlreadyExists');
                } else if (res.status === 204) {
                    refAlert.showAlert = true;
                    refAlert.type = "danger";
                    refAlert.message = res ? res : fetchCreateNewUserLabel('CreateNewUser.CreateNoResponseMessage');
                }
                else {
                    refAlert.showAlert = true;
                    refAlert.type = "danger";
                    refAlert.message = fetchCreateNewUserLabel('CreateNewUser.CreateErrorMessage');
                }
                setAlert(refAlert)
            },
            (err) => {
                console.log(err);
            }
        );
    }

    const showModal = () => {
        let refAlert = JSON.parse(JSON.stringify(alert));
        refAlert.showAlert = false;
        setAlert(refAlert)
    }

    const handleStatusChange = (e) => {
        setStatus(e.target.value)
    }

    const showSearchAlert = () => {
        let refAlert = JSON.parse(JSON.stringify(alertForSearch));
        refAlert.showAlert = false;
        setAlertForSearch(refAlert)
    }

    const trackAction = async (firstName, preferredName, userRoleId) => {
        let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));
        let todayDate = new Date();
        let userId = context.userAccountData && context.userAccountData?.id;

        let roleList = userRoleList && userRoleList.filter((x) => x.roleId == userRoleId);
        let roleName = roleList && roleList[0] && roleList[0]?.role;

        let payload = {
            "StaffId": userId,
            "SourceId": firstName,
            "Type": "Users",
            "Value": preferredName ? preferredName + " as " + roleName : firstName + " as " + roleName,
            "TriggeredTimeStamp": todayDate,
            "CreatedTimeStamp": todayDate,
            "CreatedBy": userId,
            "UpdatedTimeStamp": todayDate,
            "UpdatedBy": "NULL"
        }

        await CreateNewUserActions.TrackAction(payload).then(
            (res) => {
                if (res.status === 200 || res.status === 204) {
                    console.log("api succeeded")
                }
                else {
                    refErrorMessageAlert.showAlert = true;
                    setErrorAlert(refErrorMessageAlert);
                    window.scrollTo(0, 0);
                }
            },
            (err) => {
                console.log(err);
            }
        );
    }

    const fetchTimeZone = async () => {
        let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));
        await CreateNewUserActions.GetTimeZone(context?.userDetails?.language).then(
            (res) => {
                if (res.status === 200 || res.status === 204) {
                    let arrTimezone = []

                    const data = res?.data;

                    !!data && data.filter((item) => {
                        if (item.key === "timezone") {
                            item?.items?.map((tz) => {
                                arrTimezone.push({
                                    "name": tz.title,
                                    "value": tz.id
                                })
                            });
                        }
                    });

                    setTimeZoneOptions(arrTimezone)
                }
                else {
                    refErrorMessageAlert.showAlert = true;
                    setErrorAlert(refErrorMessageAlert);
                    window.scrollTo(0, 0);
                }
            },
            (err) => {
                console.log(err);
            }
        );
    }

    const fetchCronofyServiceAccount = async () => {
        await UserDetailsActions.GetCronofyServiceAccount().then(
            (res) => {
                if (res.status === 200 || res.status === 204) {
                    setCronofyServiceAccount(res?.data)
                }
                else {
                    window.scrollTo(0, 0);
                }
            },
            (err) => {
                console.log(err);
            }
        );
    }

    useEffect(() => {
        fetchCreateNewUserJson();
        fetchTimeZone();
        getCountriesList();
        fetchUserRoles();
        fetchCronofyServiceAccount();
    }, []);

    useEffect(() => {
        if (!!userRoleList && userRoleList.length) {

            let clientRoles = [];
            let candidateRoles = [];
            //const regex = /A1|A2|A3/;

            userRoleList.forEach((item) => {
                if (item?.groupName === 'G3') {
                    clientRoles.push(item)
                } else if (item?.groupName === 'G2') {
                    candidateRoles.push(item)
                }
            })
            setCandidatePortalRoleList(candidateRoles)
            setClientPortalRoleList(clientRoles)
        }
    }, [userRoleList]);

    /**disabling logic for roles */
    const [disabledCandidatePortalRole, setDisabledCandidatePortalRole] = useState(false)
    const [disabledClientPortalRole, setDisabledClientPortalRole] = useState(false)
    useEffect(() => {
        if (!!isEnterpriseAdmin) {
            /**clearing all selected items */
            //setCandidatePortalRoleList([])
            //setClientPortalRoleList([])
            setUserRole('');
            setClientUserRole('');

            /**disabled state */
            setDisabledCandidatePortalRole(true)
            setDisabledClientPortalRole(true)
        } else {
            // setDisabledCandidatePortalRole(false)
            // setDisabledClientPortalRole(false)

            /**access control for candidate portal */
            if (!!isEnterpriseAdminType) {
                setDisabledCandidatePortalRole(false)
            } else {
                if (!!hasSuperAdminAccess) {
                    setDisabledCandidatePortalRole(false)
                } else {
                    setDisabledCandidatePortalRole(true)
                }
            }

            /**access control for client portal */
            if (!!isEnterpriseAdminType) {
                setDisabledClientPortalRole(false)
            } else {
                if (!!hasA1Access) {
                    setDisabledClientPortalRole(false)
                } else {
                    setDisabledClientPortalRole(true)
                }
            }
        }
    }, [isEnterpriseAdmin, isEnterpriseAdminType, clientPortalAdminType, candidatePortalAdminType])

    return (
        <React.Fragment>
            <Col lg='12'>
                <Container fluid className="p-0">
                    {errorAlert?.showAlert &&
                        <ErrorAlertMessage alertMessage="AllPages.ErrorAlertMessage" showAlert={showErrorModal} />
                    }
                    <h1 className="h3 m-3"> {fetchCreateNewUserLabel('CreateNewUser.CreateNewUserHeader')}</h1>
                    <Row>
                        <Card>
                            <Card.Body>
                                <Card.Title>{fetchCreateNewUserLabel('CreateNewUser.ActiveEmailAddress')}</Card.Title>
                                <Form inline="true">
                                    <Row>
                                        <Col lg={6}>
                                            <InputGroup>
                                                <Form.Control type="text" placeholder={fetchCreateNewUserLabel('CreateNewUser.Search')} aria-label="Search"
                                                    value={activeEmail} onChange={handleSearchChange} />
                                                <Button variant="" aria-label="Search Button" onClick={fetchUserDetails}>
                                                    <Search className="feather" />
                                                </Button>
                                            </InputGroup>
                                            {alertForSearch?.showAlert &&
                                                <AlertMessage alertMessage={alertForSearch?.message} alertType={alertForSearch?.type} showAlert={showSearchAlert} />
                                            }
                                        </Col>
                                    </Row>
                                </Form>
                            </Card.Body>
                            <Card.Body>
                                <Card.Title>{fetchCreateNewUserLabel('CreateNewUser.UserDetails')}</Card.Title>
                                <Form>
                                    <Row>
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label className='control-label'>{fetchCreateNewUserLabel('CreateNewUser.FirstName')}</Form.Label>
                                                <Form.Control type="text" name="firstName" placeholder={fetchCreateNewUserLabel('CreateNewUser.FirstName')}
                                                    value={graphData.firstName}
                                                    disabled />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label className='control-label'>{fetchCreateNewUserLabel('CreateNewUser.LastName')}</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="lastName"
                                                    placeholder={fetchCreateNewUserLabel('CreateNewUser.LastName')}
                                                    value={graphData.lastName}
                                                    disabled
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>{fetchCreateNewUserLabel('CreateNewUser.PreferredName')}</Form.Label>
                                                <Form.Control type="text" name="preferredName" placeholder={fetchCreateNewUserLabel('CreateNewUser.PreferredName')}
                                                    value={graphData.preferredName}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label className='control-label'>{fetchCreateNewUserLabel('CreateNewUser.Email')}</Form.Label>
                                                <Form.Control type="email" name="email" placeholder={fetchCreateNewUserLabel('CreateNewUser.Email')}
                                                    value={graphData.email} disabled />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>{fetchCreateNewUserLabel('CreateNewUser.AffiliateEmailAddress')}</Form.Label>
                                                <Form.Control
                                                    type="email"
                                                    name="affiliateEmail"
                                                    placeholder={fetchCreateNewUserLabel('CreateNewUser.AffiliateEmailAddress')}
                                                    onChange={e => {
                                                        setGraphData({
                                                            ...graphData,
                                                            [e.target.name]: e.target.value
                                                        });
                                                    }}
                                                    value={graphData.affiliateEmail}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>{fetchCreateNewUserLabel('CreateNewUser.PreferredNumber')}</Form.Label>
                                                <Form.Control type="text" name="preferredNumber" placeholder={fetchCreateNewUserLabel('CreateNewUser.PreferredNumber')}
                                                    onChange={e => {
                                                        setGraphData({
                                                            ...graphData,
                                                            [e.target.name]: e.target.value
                                                        });
                                                    }} value={graphData.preferredNumber} />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label className='control-label'>{fetchCreateNewUserLabel('CreateNewUser.TimeZone')}</Form.Label>
                                                <Form.Select name="timeZone" value={timeZone} aria-label="TimeZone Select" onChange={e => {
                                                    setTimeZone(e.target.value);
                                                }}>
                                                    <option value=''>{fetchCreateNewUserLabel('CreateNewUser.SelectTimeZone')}</option>
                                                    {timeZoneOptions.map((item) => (
                                                        <option key={item?.value} value={item?.value}>
                                                            {item?.name}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label className='control-label'>{fetchCreateNewUserLabel('CreateNewUser.Country')}</Form.Label>
                                                <Form.Select name="country" value={country} onChange={handleCountryChange} aria-label="Country Select">
                                                    <option value=''>{fetchCreateNewUserLabel('CreateNewUser.SelectCountry')}</option>
                                                    {context?.countryList?.map((item) => (
                                                        <option key={item?.standardCodeValue} value={item?.standardCodeValue}>
                                                            {item?.title}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label className='control-label'>{fetchCreateNewUserLabel('CreateNewUser.ApplicationLanguage')}</Form.Label>
                                                <Form.Select name="language" value={language} aria-label="Language Select" onChange={e => {
                                                    setLanguage(e.target.value);
                                                }}>
                                                    <option value=''>{fetchCreateNewUserLabel('CreateNewUser.SelectLanguage')}</option>
                                                    {languageList?.map((item) => (
                                                        <option key={item?.localeKey} value={item?.localeName}>
                                                            {item?.localeName}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label className='control-label'>{fetchCreateNewUserLabel('CreateNewUser.ServiceOffice')}</Form.Label>
                                                <Form.Select name="serviceOffice" value={serviceOffice} disabled={country === ''} aria-label="Service Office Select" onChange={handleServiceOfficeChange}>
                                                    <option value=''>{fetchCreateNewUserLabel('CreateNewUser.SelectOffice')}</option>
                                                    {serviceOfficeList?.map((item) => (
                                                        <option key={item?.rightOfficeId} value={JSON.stringify(item)}>
                                                            {item?.rightOfficeName}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>{fetchCreateNewUserLabel('CreateNewUser.Status')}</Form.Label>
                                                <Form.Select name="status" aria-label="Status Select" onChange={(e) => handleStatusChange(e)}>
                                                    <option value='' selected>{fetchCreateNewUserLabel('CreateNewUser.SelectStatus')}</option>
                                                    <option value='true'>{fetchCreateNewUserLabel('CreateNewUser.Status.Active')}</option>
                                                    <option value='false'>{fetchCreateNewUserLabel('CreateNewUser.Status.InActive')}</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Form>
                            </Card.Body>
                            <Card.Body>
                                <Card.Title>{fetchCreateNewUserLabel('CreateNewUser.UserRole')}</Card.Title>
                                <Form>
                                    <Row>
                                        {/* <Col md={1}> */}
                                        {/**need API integration */}
                                        <Form.Group className="mb-3">
                                            <Row className='mt-3'>

                                                <Col sm={11} className='text-left'>
                                                    <Form.Check
                                                        name='isEnterpriseAdmin'
                                                        checked={isEnterpriseAdmin}
                                                        type="checkbox"
                                                        onChange={(data) => {
                                                            setIsEnterpriseAdmin(data.target.checked);
                                                        }}
                                                        aria-label="isEnterpriseAdmin check"
                                                        label={ENPTERPRISE_ADMIN}
                                                        className="control-label"
                                                        disabled={!isEnterpriseAdminType}
                                                    />
                                                </Col>


                                            </Row>
                                        </Form.Group>
                                        {/* </Col> */}
                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label className='control-label'>Candidate Portal Role</Form.Label>
                                                <Form.Select
                                                    name="userRole" value={userRole} aria-label="User Role Select"
                                                    disabled={
                                                        !!disabledCandidatePortalRole
                                                    }
                                                    onChange={e => {
                                                        setUserRole(e.target.value);
                                                    }}
                                                >
                                                    <option value=''>{fetchCreateNewUserLabel('CreateNewUser.SelectUserRole')}</option>
                                                    {candidatePortalRoleList?.map((item) => (
                                                        <option key={item?.role} value={item?.roleId}>
                                                            {item?.role}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label className='control-label'>Client Portal Role</Form.Label>
                                                <Form.Select
                                                    name="clientUserRole"
                                                    value={clientUserRole}
                                                    aria-label="User Role Select"
                                                    disabled={
                                                        !!disabledClientPortalRole
                                                    }
                                                    onChange={e => {
                                                        setClientUserRole(e.target.value);
                                                    }}
                                                >
                                                    <option value=''>{fetchCreateNewUserLabel('CreateNewUser.SelectUserRole')}</option>
                                                    {clientPortalRoleList?.map((item) => (
                                                        <option key={item?.role} value={item?.roleId}>
                                                            {item?.role}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label className='control-label'>{fetchCreateNewUserLabel('CreateNewUser.Country')}</Form.Label>
                                                <Select
                                                    name="country"
                                                    options={userRoleCountryList}
                                                    isMulti
                                                    value={userRoleCountry}
                                                    aria-label="Role Country Select"
                                                    onChange={selected => {
                                                        selected.find(option => option.value === "all")
                                                            ? handleUserCountryChange(userRoleCountryList.slice(1)) :
                                                            handleUserCountryChange(selected);
                                                    }}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label className='control-label'>{fetchCreateNewUserLabel('CreateNewUser.ServiceOffice')}</Form.Label>
                                                <Select
                                                    name="serviceOffice"
                                                    options={userServiceOfficeList || []}
                                                    isMulti
                                                    value={userRoleServiceOffice || []}
                                                    aria-label="Role Office Select"
                                                    onChange={selected => {
                                                        handleUserServiceOfficeChange(selected);
                                                    }}
                                                    isDisabled={userRoleCountry?.length === 0}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Form>
                            </Card.Body>
                            {/* {((userRole && (userRole == "2d9917fe-7720-ed11-bd6e-501ac574d42d" || userRole == "2e9917fe-7720-ed11-bd6e-501ac574d42d"))) && */}
                            {(userRole && (fetchUserRole(userRole) === COACH || fetchUserRole(userRole) === COACH_ADMIN)) &&
                                <>
                                    <Card.Body>
                                        <Card.Title>{fetchCreateNewUserLabel("CreateNewUser.UserProfileSection")}</Card.Title>
                                        <Form>
                                            <Row>
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>{fetchCreateNewUserLabel("CreateNewUser.Bio")}</Form.Label>
                                                        <Form.Control type="text" name="bio" placeholder={fetchCreateNewUserLabel('CreateNewUser.Bio')}
                                                            onChange={e => {
                                                                setUserProfileData({
                                                                    ...userProfileData,
                                                                    [e.target.name]: e.target.value
                                                                });
                                                            }}
                                                            value={userProfileData.bio}
                                                            maxLength={3000}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>{fetchCreateNewUserLabel("CreateNewUser.Expertise")}</Form.Label>
                                                        <Form.Control type="text" name="expertise" placeholder={fetchCreateNewUserLabel('CreateNewUser.Expertise')}
                                                            onChange={e => {
                                                                setUserProfileData({
                                                                    ...userProfileData,
                                                                    [e.target.name]: e.target.value
                                                                });
                                                            }}
                                                            value={userProfileData.expertise}
                                                            maxLength={500}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>{fetchCreateNewUserLabel("CreateNewUser.LinkedInID")}</Form.Label>
                                                        <Form.Control type="text" name="linkedInID" placeholder={fetchCreateNewUserLabel('CreateNewUser.LinkedInID')}
                                                            onChange={e => {
                                                                setUserProfileData({
                                                                    ...userProfileData,
                                                                    [e.target.name]: e.target.value
                                                                });
                                                            }}
                                                            value={userProfileData.linkedInID}
                                                            maxLength={100}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>{fetchCreateNewUserLabel('CreateNewUser.TwitterID')}</Form.Label>
                                                        <Form.Control type="text" name="twitterID" placeholder={fetchCreateNewUserLabel('CreateNewUser.TwitterID')}
                                                            onChange={e => {
                                                                setUserProfileData({
                                                                    ...userProfileData,
                                                                    [e.target.name]: e.target.value
                                                                });
                                                            }}
                                                            value={userProfileData.twitterID}
                                                            maxLength={100}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>{fetchCreateNewUserLabel('CreateNewUser.Language')}</Form.Label>
                                                        <Form.Control type="text" name="language" placeholder={fetchCreateNewUserLabel('CreateNewUser.Language')}
                                                            onChange={e => {
                                                                setUserProfileData({
                                                                    ...userProfileData,
                                                                    [e.target.name]: e.target.value
                                                                });
                                                            }}
                                                            value={userProfileData.language}
                                                            maxLength={100}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </Card.Body>
                                    <>
                                        <Card.Body>
                                            <Card.Title>{fetchCreateNewUserLabel("CreateNewUser.CronofySection")}</Card.Title>
                                            <Form>
                                                <Row>
                                                    <Col md={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label className="control-label">{fetchCreateNewUserLabel("CreateNewUser.TimeZone")}</Form.Label>
                                                            <Form.Select
                                                                name="timeZone"
                                                                value={cronofyTime}
                                                                aria-label="Time Zone Select"
                                                                onChange={e => {
                                                                    setCronofyTime(e.target.value);
                                                                }}
                                                            >
                                                                <option value=''>{fetchCreateNewUserLabel('CreateNewUser.SelectTimeZone')}</option>
                                                                {cronofyTimeZone?.map((item) => (
                                                                    <option key={item?.id} value={item?.ianaTimeZoneIdentifier}>
                                                                        {item?.ianaTimeZoneIdentifier}
                                                                    </option>
                                                                ))}
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label className="control-label">{fetchCreateNewUserLabel("CreateNewUser.ServiceAccountName")}</Form.Label>
                                                            <Form.Select
                                                                name="serviceAccountName"
                                                                value={cronofyServiceAccountName}
                                                                aria-label="Service Account Name Select"
                                                                onChange={e => {
                                                                    setCronofyServiceAccountName(e.target.value)
                                                                }}
                                                            >
                                                                <option value=''>{fetchCreateNewUserLabel('CreateNewUser.SelectServiceAccountName')}</option>
                                                                {cronofyServiceAccount?.map((item) => (
                                                                    <option key={item?.serviceAccountName} value={item?.id}>
                                                                        {item?.serviceAccountName}
                                                                    </option>
                                                                ))}
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col md={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label className="control-label">{fetchCreateNewUserLabel("CreateNewUser.AvailableDay")}</Form.Label>
                                                            <Select
                                                                name="availableDay"
                                                                options={weekDaysList}
                                                                isMulti
                                                                value={weekDay}
                                                                aria-label="Available Day Select"
                                                                onChange={selected => {
                                                                    selected.find(option => option.value === "all")
                                                                        ? handleWeekDaysChange(weekDaysList.slice(1)) :
                                                                        handleWeekDaysChange(selected);
                                                                }}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label className="control-label">{fetchCreateNewUserLabel("CreateNewUser.WorkingHoursStartTime")}</Form.Label>
                                                            <Form.Select name="startTime" value={startTime} aria-label="Working hours Start time Select" onChange={e => {
                                                                setStartTime(e.target.value);
                                                            }}>
                                                                <option value=''>{fetchCreateNewUserLabel('CreateNewUser.SelectWorkingHoursStarttime')}</option>
                                                                {hoursList?.map((item) => (
                                                                    <option key={item?.id} value={item?.label}>
                                                                        {item?.label}
                                                                    </option>
                                                                ))}
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col md={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label className="control-label">{fetchCreateNewUserLabel("CreateNewUser.WorkingHoursEndTime")}</Form.Label>
                                                            <Form.Select name="endTime" value={endTime} aria-label="Working hours End time Select" onChange={e => {
                                                                setEndTime(e.target.value);
                                                            }}>
                                                                <option value=''>{fetchCreateNewUserLabel('CreateNewUser.SelectWorkingHoursEndtime')}</option>
                                                                {hoursList?.map((item) => (
                                                                    <option key={item?.id} value={item?.label}>
                                                                        {item?.label}
                                                                    </option>
                                                                ))}
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                            </Form>
                                        </Card.Body>
                                    </>
                                </>
                            }
                            <Card.Body>
                                <Form className="text-right">
                                    <Button variant="primary" onClick={createNewUser}>{fetchCreateNewUserLabel('CreateNewUser.Create')}</Button>
                                    {alert?.showAlert &&
                                        <AlertMessage alertMessage={alert?.message} alertType={alert?.type} showAlert={showModal} />
                                    }
                                </Form>
                            </Card.Body>
                        </Card >
                    </Row >
                </Container >
            </Col >
        </React.Fragment >
    )
}
export default CreateNewUser
